<template>
  <v-card>
    <v-toolbar dense dark color="green">
      <v-toolbar-title>Order Item Browse</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="
        var valueSend = [];
        sendToParentComponent(valueSend)">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-title>
      <v-text-field
        append-icon="search"
        label="Search"
        single-line
        hide-details
        v-model="searchText"
      ></v-text-field>
    </v-card-title>
    <v-card-text>
      <!-- <v-divider></v-divider> -->
      <v-data-table
        v-model="selected"
        :headers="header"
        :items="data"
        :search="searchText"
        show-select
        :options.sync="pagination"
        item-key="order_item_skey"
        class="elevation-1"
      >
        <template slot="header" slot-scope="props">
          <tr>
            <th>
              <v-checkbox
                primary
                hide-details
                @click.native="toggleAll"
                :input-value="props.all"
                :indeterminate="props.indeterminate"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr :active="props.selected">
            <td>
              <v-checkbox
                v-model="props.selected"
                primary
                hide-details
              ></v-checkbox>
            </td>
            <td class="text-xs-left">{{ props.item.order_item_id }}</td>
            <td class="text-xs-left">{{ props.item.order_item_desc }}</td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ searchText }}" found no results.
        </v-alert>
      </v-data-table>
      <!-- <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card>
              <v-divider></v-divider>
              <v-text-field
                append-icon="search"
                label="Search"
                single-line
                hide-details
                v-model="searchText"
              ></v-text-field>
              <v-data-table
                v-model="selected"
                :headers="header"
                :items="data"
                :search="searchText"
                select-all
                :options.sync="pagination"
                item-key="order_item_skey"
                class="elevation-1"
              >
                <template slot="header" slot-scope="props">
                  <tr>
                    <th>
                      <v-checkbox
                        primary
                        hide-details
                        @click.native="toggleAll"
                        :input-value="props.all"
                        :indeterminate="props.indeterminate"
                      ></v-checkbox>
                    </th>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small>arrow_upward</v-icon>
                      {{ header.text }}
                    </th>
                  </tr>
                </template>
                <template slot="items" slot-scope="props">
                  <tr :active="props.selected">
                    <td>
                      <v-checkbox
                        v-model="props.selected"
                        primary
                        hide-details
                      ></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ props.item.order_item_id }}</td>
                    <td class="text-xs-left">{{ props.item.order_item_desc }}</td>
                  </tr>
                </template>
                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                  Your search for "{{ searchText }}" found no results.
                </v-alert>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container> -->
    </v-card-text>
    <v-divider light></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        class="mb-2"
        @click="
          var valueSend = [];
          valueSend.actionReturn = 'OK'
          valueSend.dataSelected = selected
          sendToParentComponent(valueSend)"
      >
      OK
      </v-btn>
      <v-btn
        color="primary"
        class="mb-2"
        @click="
          var valueSend = [];
          sendToParentComponent(valueSend)"
      >
      Cancel
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  export default {
    props: ['receiveVar'],
    data () {
      return {
        searchText: '',
        pagination: {
          sortBy: ['order_item_id'],
          sortDesc: [false],
          itemsPerPage: 10
        },
        selected: [],
        data: [],
        header: [
          { text: 'Order Item ID', value: 'order_item_id', align: 'left' },
          { text: 'Order Item Desc', value: 'order_item_desc', align: 'left' },
        ],
      }
    },
    created: function () {
      // this.retrieveOrderItem()
    },
    methods: {
      sendToParentComponent (value) {
        this.selected = []
        value.childSend = this.$options._componentTag
        this.$emit('eventReturn', value)
      },
      /* async retrieveOrderItem () {
        await this.axios.post(process.env.VUE_APP_API + '/orderItem/retrieveOrderItem' + process.env.VUE_APP_DATABASE_TYPE)
          .then(response => {
            if (response.data.isSuccess) {
              this.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(e => {
            await this.$swal({type: 'error', title: e.message})
          })
      }, */
      async retrieveOrderItem () {
        this.dialog.dialogProgress = true
        this.progressMessage = this.$t('waiting')
        await this.axios.post(process.env.VUE_APP_API + '/orderItem/retrieveOrderItem' + process.env.VUE_APP_DATABASE_TYPE)
          .then(response => {
            if (response.data.isSuccess) {
              this.data = response.data.data
            } else {
              this.$swal({type: 'error', title: response.data.reasonText})
            }
          })
          .catch(async e => {
            await this.$swal({type: 'error', title: e.message})
          })
        this.dialog.dialogProgress = false
      },
      toggleAll () {
        if (this.selected.length) this.selected = []
        else this.selected = this.data.slice()
      },
      changeSort (column) {
        if (this.pagination.sortBy.includes(column)) {
          this.pagination.sortDesc = [!this.pagination.sortDesc[0]]
        } else {
          this.pagination.sortBy = [column]
          this.pagination.sortDesc = [false]
        }
      },
    }
  }
</script>
